<!--<div class="modal-header">
  <h4 class="modal-title pull-left">Upload</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefUpload.hide();">
    <span aria-hidden="true">X</span>
  </button>
</div>-->

  <div class="offredetailspage section-margin">
    <div class="container">
      <div class="row">
        <button type="button" class="close pull-right file-pop-up-close" aria-label="Close" (click)="CloseFile();">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h3 class="file-bluelabel margin-bottom-15">Upload</h3>
          <br />
          <div class="floatinghead clearfix">
            <file-upload [uploadType]="fileUploadType" [messageDisplayes]="1" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
          </div>
          <div class="table-responsive">
            <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
              <thead>
                <tr>
                  <th class="minwidth20">File</th>
                  <th class="minwidth20">Category</th>
                  <th class="minwidth20" *ngIf="source=='MyPortfolio'">Property/Portfolio</th>
                  <th class="minwidth20">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">

                  <td><p>{{file.name}}</p></td>
                  <td>
                    <label class="select">
                      <select class="form-control " [(ngModel)]="file.category">
                        <option value="0">--Select--</option>
                        <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                      </select>
                      <i></i>
                    </label>
                  </td>
                  <td *ngIf="source=='MyPortfolio'">
                    <label class="select">
                      <select class="form-control " [(ngModel)]="file.propertyId">
                        <option value="0">--Select--</option>
                        <option value="-1">Portfolio</option>
                        <option *ngFor="let prop of portfolioProperty" [ngValue]="prop.Id">{{prop.PropertyName}}</option>
                      </select>
                      <i></i>
                    </label>
                  </td>
                  <td>
                    <a class="remove" href="javascript:void(0);" (click)="removeImage(i,$event)" tooltip="Remove"><i class="icofont icofont-close"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div class="text-right" *ngIf="filesCollection.length > 0">
            <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
            <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload</button>
          </div>
        </div>
      </div>
    </div>
  </div>


<ng-template #DeleteDocument>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Document</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="onRemoveDocument();modalRef.hide();">Yes</button>
    </div>
  </div>

</ng-template>
<ng-template #UploadConfirmation>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Please refresh this page once the file uploads are complete.</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="uploadFiles();">OK</button>
    </div>
  </div>
</ng-template>

<!--<a (click)="download();" download>click me</a>-->
